






























































import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";
import {
  BaseDialog,
  DialogHeader,
  FormText,
  FormSelect
} from "sitewhere-ide-components";
import { VFlex, VLayout, VTab, VTabItem } from "vuetify/lib";

import ParameterExtractorConfiguration from "./extractors/ParameterExtractorConfiguration.vue";

import {
  ICommandDestinationGenericConfiguration,
  IParameterExtractorGenericConfiguration
} from "sitewhere-configuration-model";

import { required, ValidationRule, helpers } from "vuelidate/lib/validators";

/** Validator for checking if id is already used */
const idConflict: ValidationRule = helpers.withParams(
  { type: "idConflict" },
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  (value: any, vm: any) => {
    const idsInUse: string[] = vm.idsInUse;
    let conflict = false;
    idsInUse.forEach(id => {
      if (vm.id == id) conflict = true;
    });
    return !conflict;
  }
);

@Component({
  components: {
    BaseDialog,
    DialogHeader,
    FormText,
    FormSelect,
    VFlex,
    VLayout,
    VTab,
    VTabItem,
    ParameterExtractorConfiguration
  },
  validations: {
    id: {
      required,
      idConflict
    }
  }
})
export default class CommandDestinationDialog extends Vue {
  @Prop() readonly tenantId!: string;
  @Prop() readonly type!: string;
  @Prop() readonly icon!: string;
  @Prop() readonly title!: string;
  @Prop() readonly width!: number;
  @Prop() readonly cancelLabel!: string;
  @Prop() readonly createLabel!: string;
  @Prop() readonly visible!: boolean;
  @Prop() readonly idsInUse!: string[];
  @Prop() readonly parameterExtractors!: { text: string; value: string }[];
  @Ref() readonly dialog!: BaseDialog;
  @Ref() readonly extractor!: ParameterExtractorConfiguration;

  id: string | null = null;
  parameterExtractor: IParameterExtractorGenericConfiguration | null = null;

  /** Parameter extractor type */
  get extractorType(): string | null {
    return this.parameterExtractor ? this.parameterExtractor.type : null;
  }

  /** Blank configuration if type updated */
  set extractorType(value: string | null) {
    if (value) {
      this.parameterExtractor = {
        type: value,
        configuration: {}
      };
    }
  }

  /** Save dialog fields */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  save(): any {
    if (this.id && this.type && this.extractorType && this.extractor) {
      const peConfig: IParameterExtractorGenericConfiguration = this.extractor.save();
      const parameterExtractor: IParameterExtractorGenericConfiguration = {
        type: this.extractorType,
        configuration: peConfig
      };

      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      const config: any = {
        id: this.id,
        type: this.type,
        parameterExtractor: parameterExtractor
      };
      return config;
    }
  }

  /** Reset the dialog */
  reset(): void {
    this.id = null;
    this.setActiveTab(0);
    this.$v.$reset();

    /** Reset to choose first available extractor */
    if (this.parameterExtractors) {
      const etype: string = this.parameterExtractors[0].value;
      this.extractorType = etype;
    }
  }

  /** Validate fields */
  validate(): boolean {
    if (!this.extractor || !this.extractor.validate()) {
      return false;
    }
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load dialog from a given configuration */
  load(config: ICommandDestinationGenericConfiguration) {
    this.id = config.id;
    this.parameterExtractor = config.parameterExtractor;
  }

  /** Set the active tab */
  setActiveTab(tab: number): void {
    this.dialog.setActiveTab(tab);
  }

  /** Called after create button is clicked */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onCreateClicked(e: any) {
    this.$emit("createClicked", e);
  }

  /** Called after cancel button is clicked */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  onCancelClicked(e: any) {
    this.$emit("cancelClicked", e);
  }
}
